import { render, staticRenderFns } from "./interview-panel-candidate-resume.vue?vue&type=template&id=2020c80c"
import script from "./interview-panel-candidate-resume.vue?vue&type=script&lang=js"
export * from "./interview-panel-candidate-resume.vue?vue&type=script&lang=js"
import style0 from "./interview-panel-candidate-resume.vue?vue&type=style&index=0&id=2020c80c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports